import { render, staticRenderFns } from "./rotatingStyle.vue?vue&type=template&id=a64bfce8&scoped=true"
import script from "./rotatingStyle.vue?vue&type=script&lang=js"
export * from "./rotatingStyle.vue?vue&type=script&lang=js"
import style0 from "./rotatingStyle.vue?vue&type=style&index=0&id=a64bfce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64bfce8",
  null
  
)

export default component.exports